// extracted by mini-css-extract-plugin
module.exports = {"root":"Destinations_root__tANCQ","rootItem":"Destinations_rootItem__5iQB6","rootMargin":"Destinations_rootMargin__3rjVi"};